import axios from 'axios';
import { getExpressAPIHost } from '../../../../utils';

const getDeliveryDocuments = async (params) => {
    const response = await axios.get(`${getExpressAPIHost()}/delivery-documents/raw-milk`, { params });
    return response.data;
};

export default getDeliveryDocuments;
